import debounce from 'lodash/debounce';

let interval: ReturnType<typeof setTimeout>;
let lastActivity = Date.now();
const inactivityEvents = [
  'mousedown',
  'mousemove',
  'keydown',
  'scroll',
  'wheel',
  'touchstart',
  'touchmove',
  'click',
];
const debouncedLogLastActivity = debounce(logLastActivity, 500);

function logLastActivity() {
  lastActivity = Date.now();
}

export function setCallbackAfterInactivity(
  duration: number,
  callback: () => void
) {
  inactivityEvents.forEach((name) =>
    document.addEventListener(name, debouncedLogLastActivity)
  );
  interval = setInterval(() => {
    if (Date.now() - lastActivity > duration) {
      callback();
    }
  }, 1000);
}

export function clearInactivityEvents() {
  clearInterval(interval);
  inactivityEvents.forEach((name) =>
    document.removeEventListener(name, debouncedLogLastActivity)
  );
  lastActivity = Date.now();
}
